const lambdaConfig = {
  getData: "https://pcxexu5wy3u2geynpixdtwjy2m0qrjha.lambda-url.us-east-1.on.aws/",
  getNextPage: "https://73u5stfsar3aihhkjn7327bzsy0gvnug.lambda-url.us-east-1.on.aws/",
};

export default lambdaConfig;
